export const addTeaseAlert = ({
  createdAt,
  id,
  translatedTemplate
}, kind) => {
  const {
    translatedDpgName
  } = translatedTemplate;
  return {
    type: 'ADD_TEASE_ALERT',
    createdAt,
    id,
    kind,
    translatedDpgName
  };
};
export const removeTeaseAlert = notificationId => {
  return {
    type: 'REMOVE_TEASE_ALERT',
    id: notificationId
  };
};